var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      attrs: { type: "border-card" },
      model: {
        value: _vm.active,
        callback: function($$v) {
          _vm.active = $$v
        },
        expression: "active"
      }
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: "正常区盘点", name: _vm.constantMap.normal } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading.body",
                  value: _vm.loading,
                  expression: "loading",
                  modifiers: { body: true }
                }
              ]
            },
            [
              _c(
                "el-row",
                { staticClass: "filter" },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            background: "#f3f3f3",
                            height: "30px",
                            "line-height": "30px",
                            padding: "0 25px",
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c("div", [_vm._v("查询搜索")]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "auto" },
                              attrs: {
                                type: "text",
                                icon: _vm.filterFold
                                  ? "el-icon-arrow-down"
                                  : "el-icon-arrow-up"
                              },
                              on: { click: _vm.toggleFilter }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选")
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-collapse-transition", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.filterFold,
                                expression: "!filterFold"
                              }
                            ]
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { padding: "10px 25px" } },
                              [
                                _c(
                                  "el-form",
                                  {
                                    staticClass: "demo-form-inline",
                                    attrs: { inline: true, model: _vm.form }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "盘点单号" },
                                          model: {
                                            value: _vm.form.inventory_no,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "inventory_no",
                                                $$v
                                              )
                                            },
                                            expression: "form.inventory_no"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "150px" },
                                            attrs: {
                                              placeholder: "盘点状态",
                                              filterable: ""
                                            },
                                            model: {
                                              value: _vm.form.inventory_status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "inventory_status",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.inventory_status"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: "0"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.searchOptions
                                                .inventory_status,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "150px" },
                                            attrs: {
                                              placeholder: "盘点类型",
                                              filterable: ""
                                            },
                                            model: {
                                              value: _vm.form.inventory_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "inventory_type",
                                                  $$v
                                                )
                                              },
                                              expression: "form.inventory_type"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: "0"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.searchOptions.inventory_type,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "150px" },
                                            attrs: {
                                              placeholder: "盘点方式",
                                              filterable: ""
                                            },
                                            model: {
                                              value: _vm.form.inventory_model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "inventory_model",
                                                  $$v
                                                )
                                              },
                                              expression: "form.inventory_model"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: "0"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.searchOptions.inventory_model,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "150px" },
                                            attrs: {
                                              placeholder: "盘点仓区",
                                              filterable: ""
                                            },
                                            model: {
                                              value: _vm.form.area_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "area_type",
                                                  $$v
                                                )
                                              },
                                              expression: "form.area_type"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: "0"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.searchOptions.area_type,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "150px" },
                                            attrs: {
                                              placeholder: "盘点次数",
                                              filterable: ""
                                            },
                                            model: {
                                              value: _vm.form.inventory_times,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "inventory_times",
                                                  $$v
                                                )
                                              },
                                              expression: "form.inventory_times"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: "0"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.searchOptions.inventory_times,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "创建时间：" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "datetimerange",
                                            "default-time": [
                                              "06:00:00",
                                              "06:00:00"
                                            ],
                                            v: "",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.create_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "create_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.create_time"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "开始时间：" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "datetimerange",
                                            "default-time": [
                                              "06:00:00",
                                              "06:00:00"
                                            ],
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.begin_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "begin_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.begin_time"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "结束时间：" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "datetimerange",
                                            "default-time": [
                                              "06:00:00",
                                              "06:00:00"
                                            ],
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.end_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "end_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.end_time"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: { click: _vm.search }
                                          },
                                          [_vm._v("查询")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "" },
                                            on: { click: _vm.reset }
                                          },
                                          [_vm._v("重置")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "success" },
                                            on: { click: _vm.exportExcel }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      导出"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              background: "#f3f3f3",
                              height: "50px",
                              "line-height": "30px",
                              padding: "0 25px",
                              display: "flex",
                              "align-items": "center"
                            }
                          },
                          [
                            _vm._v(
                              "\n                  数据列表\n              "
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "margin-left": "auto",
                                  "margin-right": "-15px"
                                },
                                attrs: { type: "success", size: "mini" },
                                on: {
                                  click: function($event) {
                                    _vm.visible = true
                                  }
                                }
                              },
                              [_vm._v("创建盘点")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.resData
                          ? _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.tableLoading,
                                    expression: "tableLoading"
                                  }
                                ],
                                ref: "multipleTable",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  height: "800",
                                  data: _vm.resData.list,
                                  "tooltip-effect": "dark"
                                },
                                on: {
                                  "selection-change": _vm.handleSelectionChange
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    "show-overflow-tooltip": "",
                                    prop: "inventory_no",
                                    label: "盘点单号",
                                    width: "150"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    "show-overflow-tooltip": "",
                                    prop: "inventory_area_type",
                                    label: "盘点仓区",
                                    width: "150"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "areas",
                                    label: "正常区仓区"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "inventory_inventory_type",
                                    label: "盘点类型"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "inventory_inventory_model",
                                    label: "盘点方式"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "inventory_space_type_text",
                                    label: "盘点仓位类型"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "inventory_inventory_times",
                                    label: "盘点次数"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "admin_name",
                                    label: "创建人"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "create_time",
                                    label: "创建时间"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "begin_time",
                                    label: "开始时间"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "end_time",
                                    label: "结束时间"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "inventory_inventory_status",
                                    label: "盘点状态"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "speed",
                                    label: "盘点进度"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "should_count",
                                    label: "应盘数量"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "actual_count",
                                    label: "实盘数量"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "true_percent",
                                    label: "库存准确率"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "totalDiffNum",
                                    label: "差异数量（绝对值）"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "totalDiffPrice",
                                    label: "差异成本（绝对值）"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "remark",
                                    label: "备注说明"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-button", {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-edit",
                                                size: "mini",
                                                circle: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setRemark(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(scope.row.remark))
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3404298081
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { label: "操作", width: "200" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openDetail(
                                                      scope.row.inventory_id
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("明细")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openLog(
                                                      scope.row.inventory_no
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    日志"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteInventory(
                                                      scope.row.inventory_id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    废除"
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3222248876
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.resData
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "right",
                              padding: "25px"
                            }
                          },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "current-page": _vm.curPage,
                                background: "",
                                layout:
                                  "total, prev, pager, next, jumper ,sizes",
                                total: _vm.resData.count,
                                "page-size": _vm.form.pagesize,
                                "page-sizes": [50, 100, 200, 500, 1000]
                              },
                              on: {
                                "update:currentPage": function($event) {
                                  _vm.curPage = $event
                                },
                                "update:current-page": function($event) {
                                  _vm.curPage = $event
                                },
                                "current-change": _vm.handleCurrentChange,
                                "size-change": _vm.handleSizeChange
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: { title: "备注", visible: _vm.remarkVisible },
                  on: {
                    "update:visible": function($event) {
                      _vm.remarkVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "备注" },
                            model: {
                              value: _vm.remark,
                              callback: function($$v) {
                                _vm.remark = $$v
                              },
                              expression: "remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.remarkVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.doRemark }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.visible
                ? _c("Add", { on: { onCloseDialog: _vm.closeBox } })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        { attrs: { label: "次品区盘点", name: _vm.constantMap.defective } },
        [
          _c("YsDataTable", {
            attrs: {
              refresh: _vm.refreshDefective,
              list: _vm.searchListDefective,
              "button-list": _vm.buttonListDefective,
              "fetch-method": _vm.fetchMethodDefective,
              columns: _vm.columnsDefective,
              "dep-option-map": _vm.searchOptions,
              "use-data-field": "",
              "page-size-alias": "pageSize"
            },
            scopedSlots: _vm._u([
              {
                key: "actions",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        staticStyle: { margin: "4px" },
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.handleViewDetail(row)
                          }
                        }
                      },
                      [_vm._v("\n          明细\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { margin: "4px" },
                        attrs: { type: "info", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.handleViewLog(row)
                          }
                        }
                      },
                      [_vm._v("\n          日志\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { margin: "4px" },
                        attrs: {
                          type: "danger",
                          size: "small",
                          disabled: [
                            _vm.constantMap.isDone,
                            _vm.constantMap.isRepealed
                          ].includes(row.inventory_status)
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleRepeal(row)
                          }
                        }
                      },
                      [_vm._v("\n          废除\n        ")]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.visibleCreate, title: "创建盘点" },
              on: {
                "update:visible": function($event) {
                  _vm.visibleCreate = $event
                },
                close: _vm.handleDialogInventoryClose
              },
              scopedSlots: _vm._u([
                {
                  key: "footer",
                  fn: function() {
                    return [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.visibleCreate = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleConfirmCreate }
                        },
                        [_vm._v("\n          确定\n        ")]
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c(
                "el-form",
                { ref: "formCreate", attrs: { model: _vm.formCreate } },
                [
                  _c("el-form-item", { attrs: { label: "盘点类型" } }, [
                    _c("span", [_vm._v("全盘")])
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "盘点方式" } }, [
                    _c("span", [_vm._v("明盘")])
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "盘点仓区" } }, [
                    _c("span", [_vm._v("次品区")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "盘点包裹",
                        prop: "packageNoList",
                        rules: _vm.rules.ruleChangeArray
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { multiple: "", filterable: "" },
                          on: { change: _vm.handlePackageChange },
                          model: {
                            value: _vm.formCreate.packageNoList,
                            callback: function($$v) {
                              _vm.$set(_vm.formCreate, "packageNoList", $$v)
                            },
                            expression: "formCreate.packageNoList"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.constantMap.optionsAll,
                              value: _vm.constantMap.optionsAll
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.optionsMap.packageList, function(item) {
                            return _c("el-option", {
                              key: item,
                              attrs: { label: item, value: item }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: _vm.constantMap.maxRemark
                        },
                        model: {
                          value: _vm.formCreate.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.formCreate, "remark", $$v)
                          },
                          expression: "formCreate.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-251c6ed6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-251c6ed6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/inventory/List.vue
// module id = null
// module chunks = 